import { render } from "./CommonButtonSecondary.vue?vue&type=template&id=561c7b64&scoped=true"
import script from "./CommonButtonSecondary.vue?vue&type=script&lang=js"
export * from "./CommonButtonSecondary.vue?vue&type=script&lang=js"

import "./CommonButtonSecondary.vue?vue&type=style&index=0&id=561c7b64&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561c7b64"]])

export default __exports__